import { NavLink, useLocation } from 'react-router-dom'

type NavItem = {
  path: string
  label: string
  icon: string
  description: string
}

const NAV_ITEMS: NavItem[] = [
  { path: '/articles',  label: 'Content',    icon: '📝', description: 'Articles & posts' },
  { path: '/media',     label: 'Media',      icon: '🖼️', description: 'File gallery'      },
  { path: '/redirects', label: 'Redirects',  icon: '↪️', description: 'SEO redirects'     },
  { path: '/flags',     label: 'Flags',      icon: '🚩', description: 'Feature flags'     },
]

export default function Sidebar() {
  const location = useLocation()

  return (
    <aside style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: 'var(--sidebar-width)',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: 'rgba(9, 20, 19, 0.92)',
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      borderRight: '1px solid var(--border)',
      zIndex: 100,
      overflow: 'hidden',
    }}>
      {/* Brand */}
      <div style={{
        padding: '20px 20px 16px',
        borderBottom: '1px solid var(--border)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{
            width: 34,
            height: 34,
            borderRadius: 8,
            background: 'linear-gradient(135deg, var(--accent) 0%, #2d6b57 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 16,
            boxShadow: '0 2px 8px rgba(64,138,113,0.3)',
            flexShrink: 0,
          }}>⚡</div>
          <div>
            <div style={{ fontWeight: 700, fontSize: '0.95rem', letterSpacing: '-0.02em', color: 'var(--text-primary)' }}>
              toolxdev
            </div>
            <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', letterSpacing: '0.05em', textTransform: 'uppercase' }}>
              Admin CMS
            </div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav style={{ flex: 1, padding: '12px 10px', overflowY: 'auto' }}>
        <div style={{ fontSize: '0.65rem', fontWeight: 600, color: 'var(--text-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', padding: '0 10px', marginBottom: 8 }}>
          Workspace
        </div>
        <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 2 }}>
          {NAV_ITEMS.map((item) => {
            const isActive = location.pathname.startsWith(item.path)
            return (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: '8px 10px',
                    borderRadius: 8,
                    textDecoration: 'none',
                    transition: 'all 0.15s ease',
                    background: isActive ? 'var(--accent-dim)' : 'transparent',
                    border: `1px solid ${isActive ? 'var(--accent-border)' : 'transparent'}`,
                    position: 'relative',
                  }}
                >
                  {isActive && (
                    <span style={{
                      position: 'absolute',
                      left: 0,
                      top: '20%',
                      height: '60%',
                      width: 3,
                      borderRadius: '0 3px 3px 0',
                      background: 'var(--accent)',
                    }} />
                  )}
                  <span style={{ fontSize: '1rem', flexShrink: 0 }}>{item.icon}</span>
                  <div style={{ minWidth: 0 }}>
                    <div style={{
                      fontSize: '0.875rem',
                      fontWeight: isActive ? 600 : 500,
                      color: isActive ? 'var(--accent-hover)' : 'var(--text-secondary)',
                      lineHeight: 1.2,
                    }}>
                      {item.label}
                    </div>
                    <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', lineHeight: 1 }}>
                      {item.description}
                    </div>
                  </div>
                </NavLink>
              </li>
            )
          })}
        </ul>
      </nav>

      {/* Footer */}
      <div style={{
        padding: '12px 16px',
        borderTop: '1px solid var(--border)',
        fontSize: '0.7rem',
        color: 'var(--text-muted)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: 'var(--success)',
            boxShadow: '0 0 6px rgba(74,222,128,0.5)',
            display: 'inline-block',
          }} />
          Edge runtime active
        </div>
        <div style={{ marginTop: 4, opacity: 0.6 }}>Phase 1 • v1.0.0</div>
      </div>
    </aside>
  )
}
